"use client";
import { useTranslations } from "next-intl";

import { Link } from "../../i18n/routing";

import MiddleHeader from "./Header/middle";
import HeaderDialog from "./Header/HeaderDialog";
import { usePathname } from "next/navigation";
import HeaderDropDown from "./Header/HeaderDropDown";

export default function Header({ locale }) {
  const t = useTranslations("header");
  const pathname = usePathname();
  const currentPath = pathname.slice(3);

  return (
    <>
      <div
        className={` ${currentPath.includes("tools") && "hidden"}  z-[99] h-[80px] fixed bg-background/90 backdrop-blur-md border-b border-b-stroke px-2 sm:px-4 xs:mb-10 sm:mb-20 flex justify-center items-center w-full
        `}
      >
        <Link href="/" className="cursor-pointer  flex   items-center">
          <svg
            className="mr-1 xs:mr-4 text-[#0F1C2E] dark:fill-white"
            width="48"
            height="48"
            viewBox="0 0 1634 775"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1175.48 725.392C1154.78 704.694 1154.78 671.136 1175.48 650.438L1400.73 425.184C1421.43 404.486 1421.43 370.929 1400.73 350.231L1175.48 124.976C1154.78 104.279 1154.78 70.7209 1175.48 50.0231L1209.02 16.4764C1229.72 -4.22132 1263.28 -4.22132 1283.98 16.4765L1617.73 350.231C1638.43 370.929 1638.43 404.486 1617.73 425.184L1283.98 758.939C1263.28 779.636 1229.72 779.636 1209.02 758.938L1175.48 725.392Z" />
            <path d="M458.731 125.392C479.429 104.694 479.429 71.1365 458.731 50.4387L425.184 16.892C404.486 -3.80579 370.929 -3.80579 350.231 16.892L16.4765 350.646C-4.22131 371.344 -4.22133 404.902 16.4765 425.6L350.231 759.354C370.929 780.052 404.486 780.052 425.184 759.354L458.731 725.807C479.429 705.11 479.429 671.552 458.731 650.854L233.477 425.6C212.779 404.902 212.779 371.344 233.476 350.646L458.731 125.392Z" />
            <path d="M779.231 16.892C799.929 -3.80579 833.486 -3.80579 854.184 16.892L1187.94 350.646C1208.64 371.344 1208.64 404.902 1187.94 425.6L854.184 759.354C833.486 780.052 799.929 780.052 779.231 759.354L445.476 425.6C424.779 404.902 424.779 371.344 445.476 350.646L779.231 16.892Z" />
          </svg>
          <p className="text-sm md:text-xl">Steam Inventory Value</p>
        </Link>
        <MiddleHeader
          scanner={t("scanner")}
          multichat={t("multichat")}
          scannerprofile={t("scannerprofile")}
          blog={t("blog")}
        />
        {/* <HeaderDialog
          home={t("home")}
          profile={t("profile")}
          locale={locale}
          scanner={t("scanner")}
          multichat={t("multichat")}
          getstarted={t("getstarted")}
          scannerprofile={t("scannerprofile")}
          blog={t("blog")}
          logout={t("logout")}
        /> */}

        <HeaderDropDown
          logout={t("logout")}
          profile={t("profile")}
          getstarted={t("getstarted")}
        />
      </div>
      <div className={`min-h-[80px] xs:mb-10  xs:mt-[24px]`}></div>
    </>
  );
}
